import React from 'react';
import { useHistory } from 'react-router';

import './forgot-password.scss';
import { ForgotPasswordFunctional } from './component/forgot-password';

const ForgotPassword = () => {
	const history = useHistory();
	return <ForgotPasswordFunctional history={history} />;
};

export default ForgotPassword;
